import React from "react";
import { ButtonSet } from "../ButtonGroup/buttonstyled";
import { useHistory } from "react-router-dom";

const ButtonGroup = () => {
  let history = useHistory();
  const signUp = () => {
    localStorage.setItem("guestUser", false);
    localStorage.setItem("postInventory", false);
    localStorage.setItem("memberShipType", "");
    history.push("/registration");
  };
  const contactUs = () => {
    history.push("/contact-us");
  };
  return (
    <>
      <ButtonSet>
        <button
          onClick={() => {
            history.push("/search-inventory");
          }}
        >
          SEARCH INVENTORY
        </button>
        <button onClick={signUp}>REGISTER NOW</button>
        <button onClick={contactUs}>CONTACT US</button>
      </ButtonSet>
    </>
  );
};

export default ButtonGroup;
